import React from 'react'
import { Card } from 'primereact/card'
import { Button } from 'primereact/button'
import { Skeleton } from 'primereact/skeleton'
import { useParams, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Helmet } from 'react-helmet-async'
import BreadcrumbsNav from '../components/BreadcrumbsNav'

const API_BASE = (import.meta as any).env?.VITE_API_BASE_URL || '/api'

const ObituaryDetail: React.FC = () => {
  const { id } = useParams()
  const { t } = useTranslation()
  const nav = useNavigate()
  const [data, setData] = React.useState<any | null>(null)
  const [loading, setLoading] = React.useState(true)

  React.useEffect(() => {
    const load = async () => {
      setLoading(true)
      try {
        const res = await fetch(`${API_BASE}/obituaries/${id}`)
        setData(res.ok ? await res.json() : null)
      } finally {
        setLoading(false)
      }
    }
    load()
  }, [id])

  if (loading) {
    return (
      <div className="max-w-60rem mx-auto py-4 px-3">
        <Skeleton width="100%" height="400px" />
      </div>
    )
  }

  if (!data) return <div className="p-4 text-center">Obituary not found</div>

  const header = data.photoUrl ? (
    <img alt={data.name} src={data.photoUrl} style={{ width: '100%', maxHeight: '400px', objectFit: 'cover' }} />
  ) : null

  return (
    <div className="max-w-60rem mx-auto py-4 px-3">
      <Helmet>
        <title>{data.name} · {t('site.obituaries')} · YarlHub</title>
        <meta name="description" content={`${data.name}${data.age ? ` (${data.age})` : ''} · ${data.residence || ''}`} />
        <script type="application/ld+json">{JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'Person',
          name: data.name,
          deathDate: data.dateOfDeath || undefined,
          homeLocation: data.residence || undefined,
          image: data.photoUrl || undefined
        })}</script>
      </Helmet>

      <div className="mb-3">
        <BreadcrumbsNav items={[{ label: t('site.obituaries'), to: '/obituaries' }, { label: data.name }]} />
      </div>

      <div className="flex justify-content-between align-items-center mb-3">
        <h1 className="text-4xl font-bold m-0 font-serif text-900">{data.name}{data.age ? ` (${data.age})` : ''}</h1>
        <Button
          label={t('back') || 'Back'}
          icon="pi pi-arrow-left"
          className="p-button-text text-orange-600"
          onClick={() => nav(-1)}
        />
      </div>

      <Card header={header} className="shadow-4 border-round-xl overflow-hidden">
        <div className="text-secondary mb-3 text-lg">
          <i className="pi pi-map-marker mr-2"></i>
          {data.residence || ''}
        </div>
        <div className="line-height-3 text-lg" style={{ whiteSpace: 'pre-line' }}>{data.content || ''}</div>
      </Card>
    </div>
  )
}

export default ObituaryDetail
